//#region IMPORT
import React, { useEffect } from 'react';
import M_TBG_CUSTOM_09 from './M_TBG_CUSTOM_09';
import { useAppNavigate } from '../../../../Hooks/back/useAppNavigate';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import { useBackStack } from '../../../../Hooks/back/useBackStack';
//#endregion

function M_TBG_CUSTOM_09F(props) {
  //#region 변수
  const { navigate } = useAppNavigate();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  //#endregion

  // 스택형 뒤로가기로 변경: 관리자 계열은 홈으로 복귀
  useBackStack({
    type: 'navigate',
    enabled: userInfo?.authCd !== 'EMPLOYEE',
    onBack: () => navigate('/Home'),
  });

  // 스택형 뒤로가기로 변경: 근로자는 종료 전 확인 시트 표시
  useBackStack({
    type: 'sheet',
    enabled: userInfo?.authCd === 'EMPLOYEE' && !bottomSheetState.bottom,
    onBack: () =>
      dispatch(BottomSheetActions.OpenBottomSheet({ type: 'backClickTbmEnd' })),
  });

  //#region 이벤트
  useEffect(() => {
    return () => {
      dispatch(BottomSheetActions.CloseBottomSheet());
    };
  }, [dispatch]);
  //#endregion

  //#region 나머지 함수
  const Complete = () => {
    dispatch(CommonActions.setActiveStep(0));
    if (userInfo?.authCd === 'EMPLOYEE') {
      navigate('/M_PPE', { state: { tbmCd: props.tbmCdRef?.current } });
    } else {
      navigate('/Home');
    }
  };
  //#endregion

  return (
    <M_TBG_CUSTOM_09
      setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
      TbmEnd={props.TbmEnd}
      Complete={Complete}
    />
  );
}

export default M_TBG_CUSTOM_09F;
